var _WindowServiceInit_activeInterfaceMenu, _WindowServiceInit_sideBarShow, _WindowServiceInit_content, _WindowServiceInit_modal, _WindowServiceInit_currentImage;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class WindowServiceInit {
    constructor() {
        _WindowServiceInit_activeInterfaceMenu.set(this, writable(null));
        _WindowServiceInit_sideBarShow.set(this, writable(false));
        this.settingMenuShow = writable(false);
        _WindowServiceInit_content.set(this, writable(null));
        _WindowServiceInit_modal.set(this, writable(null));
        _WindowServiceInit_currentImage.set(this, writable(null));
    }
    get activeInterfaceMenu() {
        return __classPrivateFieldGet(this, _WindowServiceInit_activeInterfaceMenu, "f");
    }
    get content() {
        return __classPrivateFieldGet(this, _WindowServiceInit_content, "f");
    }
    get modal() {
        return __classPrivateFieldGet(this, _WindowServiceInit_modal, "f");
    }
    get currentImage() {
        return __classPrivateFieldGet(this, _WindowServiceInit_currentImage, "f");
    }
    openModal(modal) {
        __classPrivateFieldGet(this, _WindowServiceInit_modal, "f").set(modal);
    }
    closeModal() {
        __classPrivateFieldGet(this, _WindowServiceInit_modal, "f").set(null);
    }
    openImageViewerPopup(image) {
        __classPrivateFieldGet(this, _WindowServiceInit_currentImage, "f").set(image);
    }
    closeImageViewerPopup() {
        __classPrivateFieldGet(this, _WindowServiceInit_currentImage, "f").set(null);
    }
    toggleChatInterfaceMenu(menu) {
        __classPrivateFieldGet(this, _WindowServiceInit_activeInterfaceMenu, "f").update(prev => {
            return prev !== menu ? menu : null;
        });
    }
    closeEmojiAttachView() {
        __classPrivateFieldGet(this, _WindowServiceInit_activeInterfaceMenu, "f").update(prev => {
            return prev !== 'emoji' ? prev : null;
        });
    }
    get sideBarShow() {
        return __classPrivateFieldGet(this, _WindowServiceInit_sideBarShow, "f");
    }
    toggleSideBar() {
        __classPrivateFieldGet(this, _WindowServiceInit_sideBarShow, "f").update((show) => !show);
    }
    closeSideBar() {
        __classPrivateFieldGet(this, _WindowServiceInit_sideBarShow, "f").set(false);
    }
    openContent(content) {
        __classPrivateFieldGet(this, _WindowServiceInit_content, "f").set(null);
        setTimeout(() => __classPrivateFieldGet(this, _WindowServiceInit_content, "f").set(content));
    }
    closeContent() {
        __classPrivateFieldGet(this, _WindowServiceInit_content, "f").set(null);
    }
}
_WindowServiceInit_activeInterfaceMenu = new WeakMap(), _WindowServiceInit_sideBarShow = new WeakMap(), _WindowServiceInit_content = new WeakMap(), _WindowServiceInit_modal = new WeakMap(), _WindowServiceInit_currentImage = new WeakMap();
export const WindowService = new WindowServiceInit();
